import { Box, Typography } from '@mui/material'
import { ReactNode } from 'react'

type PageSectionDividerProps = {
  title: ReactNode
  hideLine?: boolean
}

const PageSectionDivider = ({ title, hideLine = false }: PageSectionDividerProps) => (
  <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', width: '100%' }}>
    <Typography component={'h4'} variant={'h4'} color="text.highEmphasis">
      {title}
    </Typography>
    {!hideLine && <Box sx={{ borderBottom: 1, borderColor: 'divider', flexGrow: 1 }} />}
  </Box>
)

export default PageSectionDivider
